import React, { useState, useContext, useEffect } from 'react';
import DataGrid, {
    Column, Editing, Paging, Lookup, Pager, SearchPanel
} from 'devextreme-react/data-grid';
import './serviceStatus.css'
import { useSelector, useDispatch } from 'react-redux'
import axiosConfig from '../../configs/axios.config';
import axios from 'axios'
import { AccessRolesSelector } from '../../store/reducers/permistion';
import { MODULES, ACTION } from '../../configs/namePermission';
import Utils from '../../utils';

const pageSizes = [25, 50, 100];
const ListInventoryBarcode = () => {
    const dispatch = useDispatch()
    const AccessSelector = useSelector(AccessRolesSelector)
    const [loadData, setLoadData] = useState()
    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.create(axiosConfig).get('api/inventory/GetBarCodeExport')
            setLoadData(response.data.result)
        }
        fetchData()
    }, [])

    const onRowUpdated = async (value) => {
        await axios.create(axiosConfig).post('api/inventory/UpdateInventoryExport', value.data)
    };

    const onRowRemoved = async (value) => {
        await axios.create(axiosConfig).post('api/inventory/DelInventoryExport', value.data)
    };

    const onRowInserted = async (value) => {
        await axios.create(axiosConfig).post('api/ServicesIT/PostInsertServicesIT', value.data)
        const response = await axios.create(axiosConfig).get('api/ServicesIT/GetServicesIT')
        setLoadData(response.data.result)
    };

    // const onRowPrepared = (rowElement) => {
    //     if (rowElement.rowType === 'data' && rowElement.data) {
    //         if (rowElement.data.RemainingDay < 91 && rowElement.data.RemainingDay > 30)
    //             rowElement.rowElement.bgColor = "#FEE9CE";
    //         else if (rowElement.data.RemainingDay < 31)
    //             rowElement.rowElement.bgColor = "#F5C691";
    //     }

    // };


    return (
        <>
            <h1 >danh sách barcode Xuất kho</h1>
            <React.Fragment>
                <DataGrid
                    id="gridContainer"
                    dataSource={loadData}
                    keyExpr="Id"
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    showBorders={true}
                    showRowLines={true}

                    // onRowPrepared={onRowPrepared}
                    // onRowInserted={onRowInserted}
                    onRowUpdated={onRowUpdated}
                    onRowRemoved={onRowRemoved}>
                    <SearchPanel visible={true} highlightCaseSensitive={true} width={1500} />
                    <Paging enabled={true} />
                    <Editing
                        mode="row"
                        allowUpdating={Utils.checkPermistion(AccessSelector, MODULES?.LIST_EXPORT, ACTION?.UPDATE)}
                        allowDeleting={Utils.checkPermistion(AccessSelector, MODULES?.LIST_EXPORT, ACTION?.DELETE)}
                        allowAdding={false} />

                    <Column dataField="Id" caption="ID" allowEditing={false} width={50} />
                    <Column dataField="ItemCode" caption={"Mã hàng"} />
                    <Column dataField="NewItemCode" caption={"mã hàng mới"} />
                    <Column dataField="BarCode" caption={"BarCode"} width={550} />
                    <Column dataField="Qty" caption={"Số lượng"} format={"###,###,###.####"} />
                    <Column dataField="Note" caption={"Ghi chú"}/>
                    <Column dataField="S1no" caption={"Số lệnh đơn hàng"}/>
                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                    <Paging defaultPageSize={25} />
                </DataGrid>


            </React.Fragment>
        </>
    );
};



export default ListInventoryBarcode;